<template>
    <div :class="`profile-common__icon-counter profile-common__icon-counter--${props.variant}`">{{ props.counter }}</div>
</template>
<script setup lang="ts">
    type IconCounterProps = {
        counter: number;
        variant?: 'primary' | 'secondary';
    };
    const props = withDefaults(defineProps<IconCounterProps>(), {variant: 'secondary'});
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .profile-common__icon-counter {
        --counter-border-color: var(--joy-color-secondary-50);
        --counter-bg-color: var(--joy-color-secondary-10);
        --counter-txt-color: var(--joy-color-secondary-50);
        --counter-size: 40px;

        content: counter(counter);
        color: var(--counter-txt-color);
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 var(--counter-size);
        height: var(--counter-size);
        border-radius: var(--joy-core-radius-6);
        border: 2px solid var(--counter-border-color);
        background-color: var(--counter-bg-color);

        @include text.getFontBySize(primary-450);

        &--primary {
            --counter-border-color: var(--joy-color-primary-50);
            --counter-bg-color: var(--joy-color-primary-10);
            --counter-txt-color: var(--joy-color-primary-50);
        }
    }
</style>
